import { LineItemId, TransportUnitId } from '../types';

export const placedKey = (tuId: TransportUnitId, lineItemId: LineItemId) => `${tuId}:${lineItemId}`;
